import makePssError from "./makePssError";

export const RequestErrorAborted = makePssError("RequestErrorAborted");
export const RequestErrorConnection = makePssError("RequestErrorConnection");
export const RequestErrorStatus = makePssError("RequestErrorStatus");
export const RequestErrorUnauthenticated = makePssError(
  "RequestErrorUnauthenticated",
);
export const RequestErrorBadData = makePssError("RequestErrorBadData");
export const RequestErrorBadRequest = makePssError("RequestErrorBadRequest");
export const RequestErrorPreviewRestriction = makePssError(
  "RequestErrorPreviewRestriction",
);
export const RequestErrorRedirected = makePssError("RequestErrorRedirected");
export const RequestErrorUnsuccessful = makePssError(
  "RequestErrorUnsuccessful",
);
export const RequestErrorPayloadTooLarge = makePssError(
  "RequestErrorPayloadTooLarge",
);
export const RequestErrorResponseCode = makePssError(
  "RequestErrorResponseCode",
);
export const RequestErrorGuardedModule = makePssError(
  "RequestErrorGuardedModule",
);
export const RequestErrorVirtualSchema = makePssError("RequestErrorVirtualSchema");
